import React, { useEffect, useState } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom';
import ScrollToTop from '../ScrollToTop';
import Select from './templates/select/Select';
import Upload from './templates/upload/Upload';
import Preview from './templates/preview/Preview';
import { useTranslation } from 'react-i18next';
import CompanyForm from './company/form/Form'
import CompanyPreview from './company/preview/Preview';
import SetUpComplete from './complete/SetUpComplete';
import Header from './Header';


const Boarding = ({ accountData, companyDetailData }) => {

  const { t, i18n } = useTranslation();
  const [currentStep, setCurrentStep] = useState(1);

  const isAllowed = (requiredStep) => currentStep >= requiredStep;

  const [nameHeaderLabel, setNameHeaderLabel] = useState(t('boarding.pleaseSelectDocumentTemplates'))

  useEffect(() => {
    if (currentStep >= 1 && currentStep <= 3) {
      setNameHeaderLabel(t('boarding.pleaseSelectDocumentTemplates'));
    } else if (currentStep === 4 || currentStep === 5) {
      setNameHeaderLabel(t('boarding.pleaseFillCompanyData'));
    } else if (currentStep >= 6) {
      setNameHeaderLabel(t('boarding.setupComplete'));
    }
    // eslint-disable-next-line
  }, [currentStep, i18n.language]);

  const [companyIdDetect,setCompanyIdDetect]= useState('')

    useEffect(() => {
    const handlePopState = () => {
      if (companyIdDetect !== '') {
        console.log('User tried to go back after save. Refreshing...');
        window.location.reload(); 
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
    }, [companyIdDetect]);


  const Pages = () => {
    return (
      <>
       
        <Switch>
          <Route exact path='/boarding/templates/select'>
            <ScrollToTop />
            <Select
              setCurrentStep={setCurrentStep}
            />
          </Route>
          <Route exact path='/boarding/templates/upload'>
            {isAllowed(2)  ? (
              <>
                <ScrollToTop />
                <Upload
                  setCurrentStep={setCurrentStep}
                />
              </>
            ) : (
              <Redirect to='/boarding/templates/select' />
            )}
          </Route>
          <Route exact path='/boarding/templates/preview'>
            {isAllowed(3) ? (
              <>
                <ScrollToTop />
                <Preview
                  setCurrentStep={setCurrentStep}
                />

              </>
            ) : (
              <Redirect to='/boarding/templates/select' />
            )}
          </Route>
          <Route exact path='/boarding/company/form'>
            <>
              <ScrollToTop />
              <CompanyForm
                setCurrentStep={setCurrentStep}
              />
            </>

          </Route>
          <Route exact path='/boarding/company/preview'>
            {isAllowed(5)  ? (
              <>
                <ScrollToTop />
                <CompanyPreview setCurrentStep={setCurrentStep} setCompanyIdDetect={setCompanyIdDetect}/>
              </>
            ) : (
              <Redirect to='/boarding/templates/select' />
            )}
          </Route>
          <Route exact path='/boarding/complete'>
            {isAllowed(6) ? (
              <>
                <ScrollToTop />
                <SetUpComplete />
              </>
            ) : (
              <Redirect to='/boarding/templates/select' />
            )}
          </Route>

          <Redirect to='/boarding/templates/select' />

        </Switch>
      </>
    )
  }

  return (
    <>
    <Header  {...{ accountData: accountData, companyData: { name: nameHeaderLabel }, companyDetailData: companyDetailData }} />
    <Pages />
    </>
  )
}

export default Boarding